export class InvalidApiUrlError extends Error {
  constructor(message = 'API url not specified or not a string.') {
    super(message);
  }
}
